import React from 'react';
import { Link } from 'react-router-dom';
import './TargetLanding.css';
import './Sanctuary.css';
import desktop from '../../assets/Sanctuary/Desktop - 5.png';
import frame10 from '../../assets/Sanctuary/Frame 10.png';
import frame7 from '../../assets/Sanctuary/Frame 7.png';
import frame8 from '../../assets/Sanctuary/Frame 8.png';
import frame4 from '../../assets/Sanctuary/Frame 4.png';
import frame3 from '../../assets/Sanctuary/Frame 3.png';
import frame2 from '../../assets/Sanctuary/Frame 2.png';

const frameImages = [
  { src: frame10, alt: 'Sanctuary screen 10' },
  { src: frame7, alt: 'Sanctuary screen 7' },
  { src: frame8, alt: 'Sanctuary screen 8' },
  { src: frame4, alt: 'Sanctuary screen 4' },
  { src: frame3, alt: 'Sanctuary screen 3' },
  { src: frame2, alt: 'Sanctuary screen 2' },
];

const PLAY_URL = 'https://play.google.com/store/apps/details?id=com.sahgal.sanctuaryy';

const Sanctuary = () => {
  return (
    <div className="target-landing section">
      <div className="container">
        <h1 className="section__title">Sanctuary</h1>

        <p>
          <strong>Sanctuary</strong> — library management app for Indian libraries. Seats,
          students, fees aur renewals ek app mein. Built by{' '}
          <strong>Uxpert Tech Solutions</strong>.
        </p>

        <p>
          <strong>Package:</strong> <code>com.sahgal.sanctuaryy</code>
        </p>

        <p className="sanctuary-modal-note">
          Student fees go to the library’s Razorpay / bank. Sanctuary does not hold student money.
        </p>

        <div className="target-image-container">
          <img className="target-image" src={desktop} alt="Sanctuary overview" />
        </div>

        <div className="sanctuary-frames-row">
          {frameImages.map((frame) => (
            <img key={frame.alt} src={frame.src} alt={frame.alt} />
          ))}
        </div>

        <h3>Available on Play Store</h3>
        <div className="sanctuary-store-buttons">
          <a
            href={PLAY_URL}
            target="_blank"
            rel="noopener noreferrer"
            className="sanctuary-play-badge"
          >
            <img
              src="https://play.google.com/intl/en_us/badges/static/images/badges/en_badge_web_generic.png"
              alt="Get it on Google Play"
            />
          </a>
          <Link to="/projects/sanctuary" className="sanctuary-btn sanctuary-btn--page">
            Open Sanctuary site
          </Link>
          <a
            href="https://github.com/AbhaySahgal/Sanctuary.git"
            target="_blank"
            rel="noopener noreferrer"
            className="sanctuary-btn sanctuary-btn--github"
          >
            GitHub
          </a>
        </div>
      </div>
    </div>
  );
};

export default Sanctuary;
